import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../components/Home.vue'
import Verify from '../components/Verify.vue'
import Index from '../components/Index.vue'
import Verify1 from '../components/Verify1.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path: "/",
      redirect: "/index",
  },
  {
    path: "/index",
    component:Index,
    meta:{
      // 页面标题title
      title: '访客预约'
  }
  },
  {
    path: "/login",
    component: Verify,
    meta:{
      // 页面标题title
      title: '访客预约'
  }
  },
    {
      path: "/login1",
      component: Verify1,
      meta:{
        // 页面标题title
        title: '访客预约'
      }
  },
  {
    path: "/home",
    component: Home,
    meta:{
      // 页面标题title
      title: '访客预约'
  }
  }
  
]

const router = new VueRouter({
  // mode: "history",
  // base: '/fkyy/' ,//设置之后，使用 vue-router api 进行跳转 都会加上这个 fkyy 路径
  routes
})


// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err);
}
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to:将要访问的路径
  // from:从哪里访问的路径
  // next:之后要做的任务，是一个函数
  //      next（）放行， next（'/URL'）强制跳转的路径。
  if (to.path == '/index') return next();
  if (to.path == '/login') return next();// 访问路径为登录
  if (to.path == '/login1') return next();// 访问路径为登录
  // 获取flag
  const flagStr = window.sessionStorage.getItem("user");// session取值
  if (!flagStr) {
    return next('/login');// 没登录去登录
  }else{
  next();
}
})

export default router
